import { render, staticRenderFns } from "./QLServizi.vue?vue&type=template&id=1285b43e&scoped=true&"
import script from "./QLServizi.vue?vue&type=script&lang=js&"
export * from "./QLServizi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1285b43e",
  null
  
)

export default component.exports